export default "__VITE_ASSET__ByAINNQc__"